<template>
  <div id="mobileGnb" class="navbar navbar-white">
    <!-- 모바일 헤더 -->
    <div class="navbar-header">
      <!-- 메뉴 열기 버튼 -->
      <button v-show="!menuActive" type="button" class="navbar-toggle collapsed" aria-controls="mobileNav" data-target="#mobileNav" data-toggle="collapse">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span> <span class="icon-bar"></span>
      </button>
      <!-- 메뉴 닫기 버튼 -->
      <button v-show="menuActive" type="button" class="navbar-toggle close"
      aria-controls="mobileNa" data-target="#mobileNav" data-toggle="collapse">
      <span aria-hidden="true">×</span>
      </button>
      <!-- 로고 -->
      <router-link to="/" class="navbar-brand">
        <img src="~@/assets/svg/logo/logo-biz.svg" class="img-responsive" alt="Bizhaezoom Logo">
      </router-link>
    </div>
    <!-- 메뉴 -->
    <nav id="mobileNav" class="navbar-collapse collapse" aria-expanded="true">
      <!-- 상위 카테고리 -->
      <ul v-if="menuList.length > 0" class="nav navbar-nav">
        <li v-if="user.isLogin" class="nav-item nav-user">
          <div class="row">
            <div class="col-xs-5 user-name">
              <i class="glyphicon glyphicon-user"></i>
              {{ user.name }} 님
            </div>
            <div :class="['col-xs-7', 'charge-info', {'near': user.rest_days <= 5}]">
              <span v-if="showRestDays">{{ user.rest_days }}일 남음</span>
              <button type="button" class="hz-btn-default hz-btn-md" @click="toPricing">이용권</button>
            </div>
          </div>
        </li>
        <li class="nav-item" v-for="menu in menuList" :key="menu.name">
          <!-- 하위메뉴가 없을 경우 router-link 처리 -->
          <router-link v-if="menu.children.length === 0" class="nav-link" :to="menu.path" @click.native="close()">{{ menu.name }}</router-link>
          <a v-else :href="'#' + menu.code" :class="['nav-link', {'active': menu.code === currentTab }]" data-toggle="collapse">{{ menu.name }}<i class="glyphicon glyphicon-chevron-down"></i></a>
          <!-- 하위메뉴 -->
          <ul v-if="menu.children.length > 0" :id="menu.code" class="nav-menu panel-collapse collapse">
            <li v-for="children in menu.children" :key="children.name" class="nav-menu-item">
              <router-link class="nav-menu-link" :to="children.path" @click.native="close()">{{ children.name }}</router-link>
            </li>
          </ul>
        </li>
        <!-- 이용권/쿠폰 관리 -->
        <li class="nav-item">
          <router-link to="/coupon" class="nav-link" @click.native="close()">이용권관리/쿠폰함</router-link>
        </li>
        <!-- 회원사 관리 -->
        <li class="nav-item">
          <router-link to="/admin" target="_blank" class="nav-link" @click.native="close()" v-if="user.auth_level === '90'">회원사관리</router-link>
        </li>
        <!-- 로그인/로그아웃 -->
        <li class="nav-item" @click="close()">
          <a v-if="user.id" href="#" class="nav-link f-w-normal" @click.prevent="logout">로그아웃</a>
          <router-link v-else to="/login" class="nav-link f-w-normal">로그인</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'mobile-gnb',
    data () {
      return {
        menuActive: false,
        logoImage: require('../assets/svg/logo/logo-biz.svg')
      }
    },
    watch: {
      'menuActive': {
        handler (val) {
          this.$emit('setOverlay', val)
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user',
        basicMenuList: 'basicMenuList'
      }),
      menuList () {
        /**
         *
         * GNB 출력항목이 바인딩 될 수 있게끔 가공하는 함수입니다.
         * 로그인 여부에 따라 가공 기준이 되는 메뉴가 구분됩니다. (basicMenu/userMenu)
         * 각 메뉴에 level, parent_code 값으로 구분하여 가공된 데이터를 반환합니다.
         */
        const basic = this.basicMenuList
        const user = this.user
        const isLogin = user.isLogin
        // 로그인 했을 경우 사용자에게 주어진 메뉴 목록을 넣어주고, 안했을 경우 기본 메뉴 목록을 넣어준다.
        const serviceList = isLogin ? user.mobileServiceList : basic.mobileServiceList
        let parseServiceList = []

        if (serviceList && serviceList.length > 0) {
          // GNB 레이어에 출력된 level === 0에 항목을 리스트로 만들어준다.
          const parent = _.filter(serviceList, (o) => { return o.level === 0 })
          if (parent.length > 0) {
            // 부모 카테고리 갯수만큼 반복문을 실행한다.
            for (let i in parent) {
              // 부모 카테고리에 code 값을 parent_code로 가진 항목을 분류하여 하위 카테고리로 넣어준다. (children)
              const children = _.filter(serviceList, (o) => { return o.level !== 0 })
              const menuObj = Object.assign(parent[i], {
                children: _.filter(children, (o) => { return o.parent_code === parent[i].code })
              })

              // 부모-자식 형태로 가공된 객체를 반환될 리스트에 넣어준다.
              parseServiceList.push(menuObj)
            }
          }
        }

        // 가공된 데이터를 반환한다.
        return parseServiceList
      },
      currentTab () {
        // 현재 URL에 상위 코드값으로 해당되는 GNB 카테고리를 active 처리한다.
        const route = this.$route
        const meta = route.meta
        const parentCode = meta.hasOwnProperty('parentCode') ? meta.parentCode : ''

        return parentCode
      },
      showRestDays () {
        const user = this.user
        const restDays = user.rest_days
        const flag = restDays !== '' && restDays >= 0

        return flag
      }
    },
    methods: {
      openActiveMenu: function (el = null) {
        // 현재 활성화된 페이지에 nav-menu 창을 열어준다.
        if (el) {
          const activeNavLink = el[0].querySelector('.nav-link.active')
          if (activeNavLink) {
            const hasDataToggle = activeNavLink.getAttribute('data-toggle')
            if (hasDataToggle) {
              $(activeNavLink.getAttribute('href')).collapse('show')
            }
          }
        }
      },
      changeArrowIcon: function (el = null, from = '', to = '') {
        // collapse 상태에 따른 화살표 아이콘 변경
        if (el) {
          el[0].classList.remove(from)
          el[0].classList.add(to)
        }
      },
      toPricing () {
        this.$router.push({name: 'pricing'})
        this.close()
      },
      close: function () {
        // 활성화된 메뉴창을 닫는다.
        const el = this.$el
        const mobileNav = el.querySelector('#mobileNav')

        if (mobileNav) {
          $(mobileNav).collapse('hide')
        }
      },
      logout: function () {
        this.$parent.$refs.logoutModal.show()
      }
    },
    mounted: function () {
      const vm = this
      const el = vm.$el
      const mobileNav = $(el.querySelector('#mobileNav'))

      // mobile GNB collapse show event listener
      mobileNav.on('show.bs.collapse', (e) => {
        const target = e.target
        const isMobileNav = target.id === 'mobileNav'

        if (isMobileNav) {
          // 헤더에 navbar-toggle 버튼 클릭 시, 메뉴창 상태를 true로 변경
          vm.menuActive = true

          vm.$nextTick(() => {
            // 현재 페이지에 nav-menu를 열어준다.
            vm.openActiveMenu(mobileNav)
          })
        } else {
          const previousElementSibling = e.target.previousElementSibling
          const tag = previousElementSibling.getElementsByTagName('i')

          // 선택된 상위 카테고리에 화살표 아이콘 클래스를 변경한다.
          vm.changeArrowIcon(tag, 'glyphicon-chevron-down', 'glyphicon-chevron-up')

          // 상위 카테고리에 하위 메뉴가 열릴 시, 기존에 열려있던 다른 하위 메뉴를 닫는다.
          mobileNav.find('.collapse.in').collapse('hide')
        }
      })

      // mobile GNB collapse hide event listener
      mobileNav.on('hide.bs.collapse', (e) => {
        const target = e.target
        const isMobileNav = target.id === 'mobileNav'

        if (isMobileNav) {
          // 헤더에 navbar-toggle 버튼 클릭 시, 메뉴창 상태를 false를 변경
          this.menuActive = false
        } else {
          const previousElementSibling = e.target.previousElementSibling
          const tag = previousElementSibling.getElementsByTagName('i')

          // 선택된 상위 카테고리에 화살표 아이콘 클래스를 변경한다.
          vm.changeArrowIcon(tag, 'glyphicon-chevron-up', 'glyphicon-chevron-down')
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/components/mobile_gnb';

  .navbar {
    .has-notice & {
      top: 64px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileGnb.vue